<div class="daterange">

  <div #trigger
       class="z-select trigger"
       role="button"
       tabindex="0"
       aria-haspopup="dialog"
       [attr.aria-label]="label"
       [attr.aria-expanded]="open"
       [attr.aria-controls]="open ? panelId : null"
       [class.is-open]="open"
       (click)="toggle()"
       (keydown)="onTriggerKeydown($event)">

    @if (etiqueta) {
      <span class="trigger-value">{{ etiqueta }}</span>
    } @else {
      <span class="z-select-placeholder">{{ placeholder }}</span>
    }

    <span class="z-select-caret">
      @if (etiqueta) {
        <button class="clear"
                type="button"
                aria-label="Quitar el rango de fechas"
                (click)="limpiar($event)">&times;</button>
      }
      <i class="bi bi-calendar3" aria-hidden="true"></i>
    </span>
  </div>

  @if (open) {
    <div class="z-select-menu panel"
         role="dialog"
         [id]="panelId"
         [attr.aria-label]="label"
         (click)="$event.stopPropagation()">

      <div class="presets">
        @for (preset of presets; track preset.id) {
          <button class="preset" type="button" (click)="aplicarPreset(preset)">
            {{ preset.label }}
          </button>
        }
      </div>

      <div class="calendar">

        <header class="cal-head">
          <button class="nav"
                  type="button"
                  aria-label="Mes anterior"
                  [disabled]="!puedeRetroceder"
                  (click)="mesAnterior()">
            <i class="bi bi-chevron-left" aria-hidden="true"></i>
          </button>

          <span class="cal-title" aria-live="polite">{{ tituloMes }}</span>

          <button class="nav"
                  type="button"
                  aria-label="Mes siguiente"
                  [disabled]="!puedeAvanzar"
                  (click)="mesSiguiente()">
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
          </button>
        </header>

        <div class="weekdays" aria-hidden="true">
          @for (dia of diasSemana; track $index) {
            <span>{{ dia }}</span>
          }
        </div>

        <div class="grid" role="grid" (keydown)="onGridKeydown($event)" (mouseleave)="hover = null">
          @for (semana of semanas; track $index) {
            <div class="week" role="row">
              @for (celda of semana; track celda.iso) {
                <button class="day"
                        type="button"
                        role="gridcell"
                        [tabindex]="esFoco(celda) ? 0 : -1"
                        [disabled]="celda.deshabilitado"
                        [attr.aria-label]="etiquetaDia(celda)"
                        [attr.aria-selected]="esInicio(celda) || esFin(celda)"
                        [class.outside]="!celda.delMes"
                        [class.in-range]="enRango(celda)"
                        [class.edge-start]="esInicio(celda)"
                        [class.edge-end]="esFin(celda)"
                        (click)="onDia(celda)"
                        (mouseenter)="onHover(celda)">{{ celda.dia }}</button>
              }
            </div>
          }
        </div>

      </div>

      <footer class="panel-foot">
        <span class="hint" aria-live="polite">{{ resumen }}</span>
        <button class="link" type="button" (click)="limpiar()">Quitar rango</button>
      </footer>

    </div>
  }

</div>
